import React, { useRef, useEffect, useState } from 'react';
import '../styles/TermsModal.css'; // Your CSS file

const TermsPopup = ({ showPopup, handleClose, activeSection }) => {
  const termsRef = useRef(null);
  const privacyRef = useRef(null);
  const modalContentRef = useRef(null);

  const [activeTab, setActiveTab] = useState('');

  const scrollTo = (ref) => {
  if (ref?.current && modalContentRef?.current) {
    const offsetTop = ref.current.offsetTop;
    modalContentRef.current.scrollTo({
      top: offsetTop - 130, // Adjust this value as needed
      behavior: 'smooth'
    });
  }
};

console.log(activeSection)

  useEffect(() => {
    if (showPopup) {
        setActiveTab(activeSection)
        if (activeSection === 'terms') scrollTo(termsRef);
        else if (activeSection === 'privacy') scrollTo(privacyRef);
    }
  }, [showPopup, activeSection]);

//   const handleScroll = () => {
//     const scrollPos = modalContentRef.current.scrollTop;
//     const privacyOffset = privacyRef.current.offsetTop;
    
//     if (scrollPos + 100 >= privacyOffset) {
//       setActiveTab("privacy");
//     } else {
//       setActiveTab("terms");
//     }
//   };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === 'terms') scrollTo(termsRef);
    else if (tab === 'privacy') scrollTo(privacyRef);
};

  if (!showPopup) return null;

  return (
    <div className="AF-popupOverlay">
      <div className="AF-popup">
        {/* Close Button */}
        <div className="AF-header">
          <button className="AF-closeBtnLeft" onClick={handleClose}>×</button>
        </div>

        {/* Tab Buttons */}
        <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
       <button
        className={`AF-submitBtn ${activeTab === "terms" ? "active" : ""}`}
        onClick={() => handleTabClick("terms")}
        >
        Terms & Conditions
        </button>
        <button
        className={`AF-submitBtn ${activeTab === "privacy" ? "active" : ""}`}
         onClick={() => handleTabClick("privacy")}
        >
        Privacy Policy
        </button>
</div>

        {/* Modal Scrollable Content */}
        <div 
            ref={modalContentRef}
            className="AF-modal-content" 
            style={{ maxHeight: '400px', overflowY: 'auto', marginTop: '40px', paddingRight: '10px' }}
        >
          
          {/* Terms of Service Section */}
          <div ref={termsRef} className='terms-privacy-container'>
            <h2 className="form-label-join-term">Terms of Service</h2>
            {/* <p><strong>Last updated:</strong> 6 August 2025</p> */}
            <p>Welcome to mybetbuilders.com, a free beta tool developed by Quotus Limited. By using the site, you agree to these terms.</p>

            <h3>1. Beta Disclaimer</h3>
            <p>This is a beta version. Features may change or break without notice. We offer no guarantee of accuracy, availability, or uninterrupted use.</p>

            <h3>2. No betting advice</h3>
            <p>Our tools are for informational purposes only. We are not a betting operator and do not place bets on your behalf. You are solely responsible for any betting decisions made using this site.</p>

            <h3>3. Intellectual Property</h3>
            <p>All site content, including tools and designs, belongs to Quotus Ltd and must not be copied or repurposed without written permission.</p>

            <h3>4. Limitation of Liability</h3>
            <p>We are not liable for any direct or indirect loss arising from your use of the site.</p>

            <h3>5. Termination</h3>
            <p>We reserve the right to suspend or remove access to the site at any time, especially during this beta period.</p>

            <h3>6. Changes to Terms</h3>
            <p>We may update these terms at any time. Continued use of the site means you accept the updated terms.</p>

            <h3>7. Governing Law</h3>
            <p>These terms are governed by the laws of England and Wales, and any disputes will be resolved in the UK courts.</p>
          </div>

          <hr />

          {/* Privacy Policy Section */}
          <div className='terms-privacy-container' ref={privacyRef} style={{ marginTop: '40px' }}>
            <h2 className="form-label-join-term">We value Your privacy</h2>
            <p>This Privacy Policy explains how we collect, use, and protect your personal data when you use <strong>mybetbuilders.com</strong>.</p>

            <h3>1. Who we are</h3>
            <p>We are Quotus Limited, the company behind mybetbuilders.com. For any data queries, contact us at: <a href="mailto:contact@mybetbuilders.com">contact@mybetbuilders.com</a></p>

            <h3>2. What data we collect</h3>
            <p>During this free beta period, we may collect:</p>
            <ul className='term-ul-li'>
              <li className='term-ul-li'>Email address (if submitted via feedback form or email capture prompt)</li>
              <li className='term-ul-li'>Usage data (e.g. page views, button clicks)</li>
              <li className='term-ul-li'>Device/browser information (for analytics and site performance)</li>
            </ul>

            <h3>3. Why we collect your data</h3>
            <p>We collect your data to:</p>
            <ul>
              <li>Provide and improve our services</li>
              <li>Contact you with updates or future product offers (only if you've opted in)</li>
              <li>Understand how users interact with the platform</li>
            </ul>
            <p><strong>Our legal basis for processing your data is:</strong></p>
            <ul>
              <li>Consent (when you give us your email)</li>
              <li>Legitimate interest (to improve the website)</li>
            </ul>

            <h3>4. Your rights under UK GDPR</h3>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Request correction or deletion</li>
              <li>Withdraw consent at any time</li>
              <li>Lodge a complaint with the UK ICO</li>
            </ul>
            <p>To make a request, email: <a href="mailto:contact@mybetbuilders.com">contact@mybetbuilders.com</a></p>

            <h3>5. Data security</h3>
            <p>We take reasonable steps to keep your information safe. Data is stored securely and is not sold or shared with third parties.</p>

            <h3>6. Cookies</h3>
            <p>We use basic cookies to:</p>
            <ul>
              <li>Understand how users interact with the site (via analytics)</li>
              <li>Improve functionality</li>
            </ul>
            <p>You can control cookies in your browser settings. We will display a cookie banner to inform you.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPopup;
